import empty from '@/views/default/empty'
import Account from "@/views/account/Account"
import List from "../../views/account/List"
export default [
  {
    path: '/account',
    name: 'Account',
    component: empty,
    children: [
      {
        path: "maintain",
        name: "GROUP_ACCOUNT_MAINTAIN",
        component: Account,
      }, {
        path: "list",
        name: "GROUP_ACCOUNT_LIST",
        component: List,
      },
    ]
  }
]
